import styled from 'styled-components'
import {NavLink} from '@components/lib'

import {ReactComponent as NotificationSvg} from 'images/icons/notification-icon.svg'

export const NotificationWrapper = styled(NavLink)`
  position: relative;
  background: none;
  width: 68px;
  padding: 0;
  border: none;
  border-left: 1px solid ${({theme}) => theme.colors.border};
  border-right: 1px solid ${({theme}) => theme.colors.border};
`

export const NotificationIcon = styled(NotificationSvg)`
  width: 18px;
  fill: currentColor;
`

export const NotificationCountLabel = styled.div`
  position: absolute;
  top: calc(50% - 18px);
  left: calc(50% + 4px);
  background: ${({theme}) => theme.colors.orange};
  border-radius: 50%;
  width: 14px;
  height: 14px;
  font-weight: 600;
  font-family: ${({theme}) => theme.fontFamilies.title};
  font-size: 10px;
  line-height: 1;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
`
